import { dialog } from "../../../nq-component";
import BaseListPresenter from "../../../base/BaseListPresenter";
import changes from "../../../changes";
import camelToTitleCase from "../../../camelToTitleCase";

class ReceiptListPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    getCurrentUserUseCase,
    updateObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      deleteObjectUseCase,
      upsertUseCase,
      getCurrentUserUseCase,
      updateObjectUseCase,
    );
    this.getCurrentUserUseCase = getCurrentUserUseCase;
    this.updateObjectUseCase = updateObjectUseCase;
    this.objects = [];
  }

  async componentDidMount() {
    const clientId = this.view.getClientId();
    if (clientId) {
      await this.getUserClient();
    }

    this.init();
    return this.getObjects();
  }

  init() {
    const user = this.view.getCurrentUser();
    const clientId = this.view.getClientId();
    const month = this.view.getParamsMonth();
    const year = this.view.getParamsYear();
    const isAdmin = this.view.isAdmin();

    const start = new Date(year, month - 1, 1);
    const end = new Date(year, month, 1);

    this.limit = 20;
    this.where = {
      date: { $gte: start, $lt: end },
      client: { id: clientId || user?.client?.id },

      ...(isAdmin && { status: { $ne: "non-vat" } }),
    };
    this.search = {};
    this.filter = {};
    this.include = ["client", "supplier", "bank"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  async onSubmitModal(collection, object) {
    const updatedObject = { ...object };
    try {
      this.view.showProgress();

      await this.upsertUseCase.execute(collection, updatedObject);

      this.view.hideProgress();
      this.view.showSuccess("Data Added Successfully!");
    } catch (error) {
      this.view.showError(error);
    }
  }

  getMonths() {
    const year = new Date().getFullYear();
    const months = Array.from({ length: 12 }, (_, i) => {
      return new Intl.DateTimeFormat("en-US", { month: "long" }).format(
        new Date(year, i, 1),
      );
    });

    return months;
  }

  async onSubmit(updatedObject, originalObject) {
    const collection = this.view.getCollectionName();
    const route = this.view.getBaseRoute();
    const isAdmin = this.view.isAdmin();
    const clientId = this.view.getClientId();
    const hasChanges = changes(originalObject, updatedObject);

    const updatedReceipt = {
      ...updatedObject,
      vatExempt: updatedObject?.supplier?.isVatable
        ? updatedObject?.vatExempt
        : 0,
      status: isAdmin
        ? updatedObject?.status
        : updatedObject?.supplier?.isVatable
          ? "pending"
          : "non-vat",
    };

    console.warn("updatedReceipt", updatedReceipt);
    try {
      dialog.close();

      const object = await this.upsertUseCase.execute(
        collection,
        updatedReceipt,
        route,
      );

      this.objects.map((obj) => (obj.id === object?.id ? object : obj));

      if (Object.keys(hasChanges).length > 0) {
        const changeSummary = Object.entries(hasChanges)
          .map(([key, value]) => {
            const display =
              value != null &&
              typeof value === "object" &&
              !(value instanceof Date)
                ? (value?.name ?? value?.id ?? "[object]")
                : String(value);
            return `${camelToTitleCase(key)}: ${display}`;
          })
          .join(", ");

        if (isAdmin) {
          await this.createNotification({
            title: "Purchases updated",
            description: `A purchase record was updated by accountant: ${changeSummary}`,
            route: route,
            refId: clientId,
            client: { id: clientId },
          });
        }
      }
      this.getObjects();
      // this.view.setObjects(this.objects);
      this.view.showSuccess("Object Updated Successfully!");
    } catch (error) {
      this.view.showError(error);
    }
  }

  async purchasesAudited(data) {
    const collection = this.view.getCollectionName();
    const isMultiple = Array.isArray(data);
    const objectsToAudit = isMultiple ? data : [data];
    const route = this.view.getBaseRoute();
    const clientId = this.view.getClientId();
    const { objects } = this.view.state;
    const idsToAudit = objectsToAudit.map((o) => o.id).filter(Boolean);

    if (idsToAudit.length === 0) return;

    try {
      this.view.showProgress();

      await Promise.all(
        idsToAudit.map((id) =>
          this.updateObjectUseCase.execute(collection, {
            id,
            status: "audited",
          }),
        ),
      );

      const idSet = new Set(idsToAudit);
      const updatedObjects = objects.map((object) =>
        idSet.has(object.id) ? { ...object, status: "audited" } : object,
      );
      this.objects = updatedObjects;

      this.view.setState((prevState) => ({
        ...prevState,
        objects: [...updatedObjects],
        selected: [],
      }));

      this.view.hideProgress();

      const successMessage = isMultiple
        ? `${idsToAudit.length} Purchases Audited Successfully!`
        : "Purchases Audited Successfully!";

      await this.createNotification({
        title: "Purchases audited",
        description: isMultiple
          ? `${idsToAudit.length} purchase(s) were audited by admin`
          : "Purchases were audited by admin",
        route: route,
        refId: clientId,
        client: { id: clientId },
      });
      this.view.showSuccess(successMessage);
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }

  async getUserClient() {
    const collection = "users";
    const clientId = this.view.getClientId();
    const query = {
      where: {
        client: {
          id: clientId,
        },
      },
      include: ["client"],
    };
    try {
      this.showProgress();

      const user = await this.findObjectUseCase.execute(collection, query);
      await new Promise((resolve) => {
        this.view.setState(
          { userObject: user[0] ? { ...user[0] } : {} },
          resolve,
        );
      });
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
  }
}

export default ReceiptListPagePresenter;
